import * as React from 'react';
export var CustomizerContext = React.createContext({
  customizations: {
    inCustomizerContext: false,
    settings: {},
    scopedSettings: {}
  }
});